import { create } from "zustand";
import { devtools } from "zustand/middleware";

const initialState = {
  merchantList: [],
  merchantFilterSearchQuery: {
    left_progression_filter: "active",
    search: "",
    sortBy: "created_at",
    sortValue: "DESC",
    manager_id: [],
    progression_id: [],
    page: 1,
    merchants: true,
  },
  pageCount: 0,
  currentPage: 1,
  activeApp: null,
};

const useMerchantStore = create(
  devtools((set) => ({
    ...initialState,

    setActiveApp: (app) => set({ activeApp: app }),
    setMerchantList: (list) => set({ merchantList: list }),
    setMerchantFilterSearchQuery: (query) =>
      set((state) => ({
        merchantFilterSearchQuery: {
          ...state.merchantFilterSearchQuery,
          ...query,
        },
      })),
    setPageCount: (count) => set({ pageCount: count }),
    setCurrentPage: (page) => set({ currentPage: page }),
    reset: () => set(initialState),
  })),
);

export default useMerchantStore;
